import { Box, styled } from '@ltvco/refresh-lib/theme';

export const ErrorContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));
